import type { EntitlementDecision, FeatureKey } from '@/api/entitlements';

import { useEntitlements } from './use-entitlements';

const isPlanAvailabilityDenial = (decision?: EntitlementDecision) => {
    if (!decision || decision.allowed) return false;
    if (decision.reason === 'feature_not_in_plan') return true;

    return decision.reason === 'resource_cap_exceeded' && decision.limit === 0;
};

export function useFeatureEntitlement(feature: FeatureKey) {
    const { features, isLoading, isFetching, isError } = useEntitlements();
    const decision = features[feature];
    const isDenied = !isLoading && !isError && decision?.allowed === false;
    const isUnavailableInPlan = !isLoading && !isError && isPlanAvailabilityDenial(decision);
    const isQuotaExceeded = isDenied && decision?.reason === 'quota_exceeded';
    const isResourceCapExceeded = isDenied && decision?.reason === 'resource_cap_exceeded';

    return {
        decision,
        isAllowed: decision?.allowed ?? true,
        isDenied,
        isError,
        isFetching,
        isLoading,
        isQuotaExceeded,
        isResourceCapExceeded,
        isUnavailableInPlan,
        availableFromPlan: decision?.available_from_plan ?? null,
        shouldBlock: isDenied,
    };
}
